import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmActionComponent } from 'src/app/app-layout/modal-confirm-action/modal-confirm-action.component';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { UserPersonSharedService } from 'src/app/services/shared/user/person/sharedPerson.service';
@Component({
  selector: 'apc-multi-action-buttons',
  templateUrl: './multi-actions.component.html',
  styleUrls: ['../action-buttons.component.scss'],
})
export class AllActionsComponent implements OnInit {
  @Output() editEvent = new EventEmitter<boolean>(false);
  @Output() saveEvent = new EventEmitter<boolean>(false);
  @Output() cancelEvent = new EventEmitter<boolean>(false);
  @Output() deleteEvent = new EventEmitter<boolean>(false);
  @Output() cloneEvent = new EventEmitter<boolean>(false);
  @Output() joinEvent = new EventEmitter<string>(false);
  @Output() readDisable = new EventEmitter<boolean>(false);
  @Output() splitEvent = new EventEmitter<string>(false);
  @Output() fillFullTimeEvent = new EventEmitter<boolean>(false);
  @Output() checkExpirationDate = new EventEmitter<boolean>(false);
  @Input() public edit: boolean = false;
  @Input() disableSave: boolean = false;
  @Input() disableDelete: boolean = false;
  @Input() hideExtraFields: boolean = false;
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() personaSubsectionIdentifier: string;
  @Input() personaIdentifier: string;
  @Input() form: any;
  @Input() formId: string;
  @Input() indexRow: number;

  public permissionHistory: Object = '';
  public permissionEdit: Object = null;
  public isArchived: boolean = false;

  constructor(private modalService: NgbModal, private userPersonSharedService: UserPersonSharedService) {}

  ngOnInit(): void {
    let isAdmin = false;
    let permission = localStorage.getItem(LocalStorageKeyEnum.PERMISSIONS);
    if(permission != null && typeof permission != typeof undefined){
      isAdmin = JSON.parse(permission).role == 'Admin';
    }
    this.userPersonSharedService.isArchived$.subscribe(e=>{ this.isArchived = !e});


    this.permissionHistory = isAdmin
      ? null
      : {
          pertinence: this.pertinence,
          section: this.section,
          subsection: this.subsection,
          context: 'history',
          type: 'READER',
        };
    if (this.section === 'operations' && this.subsection.includes('kpi')) {
      this.subsection = 'kpi';
    }
    this.permissionEdit = isAdmin
      ? null
      : {
          pertinence: this.pertinence,
          section: this.section,
          subsection: this.subsection,
          context: 'metadata',
          type: 'EDITOR',
        };
  }

  editForm(disa: boolean, e?: any) {
    if(!disa) this.readDisable.emit(false);
    this.edit = !this.edit;
    setTimeout(() => {
      e && window.scrollTo({ top: e.layerY - 115, behavior: 'smooth' });
    }, 100);
    this.editEvent.emit(this.edit);
  }

  saveForm() {
    this.readDisable.emit(true);
    if(this.subsection == "achievement"){
      this.checkExpirationDate.emit();
    }else{
      this.saveEvent.emit(true);
    }
    
  }

  cancelForm() {
    if (this.form?.dirty) {
      const modalRef = this.modalService.open(ModalConfirmActionComponent);
      modalRef.componentInstance.message = 'modals.message.undoChangesMessage';
      modalRef.result.then((result) => {
        if (result) {
          this.confirmCancelForm();
        }
      });
    } else {
      this.confirmCancelForm();
    }
  }

  confirmCancelForm() {
    this.cancelEvent.emit(true);
    this.editForm(true);
  }

  cloneForm() {
    this.cloneEvent.emit(true);
  }

  fillFullTime() {
    this.fillFullTimeEvent.emit(true);
  }

  delete() {
    this.deleteEvent.emit(true);
  }

  joinCompany(){
    this.joinEvent.emit(this.personaSubsectionIdentifier);
  }
  splitCompany(){
    this.splitEvent.emit(this.personaSubsectionIdentifier);
  }
}
